import { GatheringFields } from 'main/gql/gathering/'
import { GatheringRegistrations_gatheringRegistrations } from 'main/gql/registration/'
import { User_user } from 'main/gql/user'
import { UpdateGatheringRegistration_updateGatheringRegistration } from './gql'

export interface IRegistration {
  id: number
  quantity: number
}

export enum StepName {
  Login = 'login',
  SignUp = 'sign_up',
  Register = 'register',
  Update = 'update',
  Confirmation = 'confirmation',
}

export interface ISignUpStep {
  __stepname: StepName.SignUp
}

export interface ILoginStep {
  __stepname: StepName.Login
}

export interface IRegisterStep {
  __stepname: StepName.Register
  gathering: GatheringFields
  user: User_user
}

export interface IUpdateStep {
  __stepname: StepName.Update
  registration: GatheringRegistrations_gatheringRegistrations
  user: User_user
}

export interface IConfirmationStep {
  __stepname: StepName.Confirmation
  gathering: GatheringFields
  registration:
    | GatheringRegistrations_gatheringRegistrations
    | UpdateGatheringRegistration_updateGatheringRegistration
  user: User_user
}

export type Step = ISignUpStep | ILoginStep | IRegisterStep | IUpdateStep | IConfirmationStep
